import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const DashboardIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="sidebar-icon">
        <rect x="2.5" y="2.5" width="6.5" height="6.5" rx="1.8" stroke="currentColor" strokeWidth="2" />
        <rect x="11" y="2.5" width="6.5" height="6.5" rx="1.8" stroke="currentColor" strokeWidth="2" />
        <rect x="11" y="11" width="6.5" height="6.5" rx="1.8" stroke="currentColor" strokeWidth="2" />
        <rect x="2.5" y="11" width="6.5" height="6.5" rx="1.8" stroke="currentColor" strokeWidth="2" />
    </svg>
);

const ProductIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" className="sidebar-icon">
        <path d="M17.5 13.5V6.5A1.5 1.5 0 0 0 16.75 5.2L10.75 1.7A1.5 1.5 0 0 0 9.25 1.7L3.25 5.2A1.5 1.5 0 0 0 2.5 6.5V13.5A1.5 1.5 0 0 0 3.25 14.8L9.25 18.3A1.5 1.5 0 0 0 10.75 18.3L16.75 14.8A1.5 1.5 0 0 0 17.5 13.5Z" />
        <polyline points="2.7 5.8 10 10 17.3 5.8" />
        <line x1="10" y1="18.3" x2="10" y2="10" />
    </svg>
);

const OrderIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" className="sidebar-icon">
        <circle cx="7.5" cy="17" r="1.2" fill="currentColor" />
        <circle cx="16" cy="17" r="1.2" fill="currentColor" />
        <path d="M1.5 2H4.2L6.3 12.2A1.5 1.5 0 0 0 7.8 13.5H15.2A1.5 1.5 0 0 0 16.7 12.2L18 5.5H5.2" />
    </svg>
);

const HarvestIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" className="sidebar-icon">
        <path d="M10 18V9" />
        <path d="M10 13.5C7.2 13.5 5 11.2 5 8.2C7.8 8.2 10 10.5 10 13.5Z" />
        <path d="M10 11C12.8 11 15 8.8 15 5.8C12.2 5.8 10 8 10 11Z" />
        <path d="M10 15.5C12.2 15.5 14 13.8 14 11.5C12.2 11.5 10 13.2 10 15.5Z" />
    </svg>
);

const TransactionIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" className="sidebar-icon">
        <rect x="2" y="3.5" width="16" height="13" rx="2" />
        <line x1="2" y1="8" x2="18" y2="8" />
        <line x1="5" y1="12.5" x2="8.5" y2="12.5" />
    </svg>
);

const TabComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;

    const isDashboard = currentPath.includes("dashboard") || currentPath === "/" || currentPath === "";
    const isProduct = currentPath.includes("product-mangement") || currentPath.includes("product-management");
    const isOrder = currentPath.includes("order-mangement") || currentPath.includes("order-management");
    const isHarvest = currentPath.includes("harvest-tracking");
    const isTransaction = currentPath.includes("transaction");

    const redirectTo = (url) => {
        navigate(url);
    };

    return (
        <div className="common-tabs">
            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <button
                        className={isDashboard ? "nav-link active" : "nav-link"}
                        onClick={() => redirectTo("/dashboard")}
                        id="dashboard-tab"
                    >
                        <DashboardIcon />
                        <span>Dashboard</span>
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={isProduct ? "nav-link active" : "nav-link"}
                        onClick={() => redirectTo("/product-mangement/products")}
                        id="product-management-tab"
                    >
                        <ProductIcon />
                        <span>Product Management</span>
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={isOrder ? "nav-link active" : "nav-link"}
                        onClick={() => redirectTo("/order-mangement/order-management-view")}
                        id="order-management-tab"
                    >
                        <OrderIcon />
                        <span>Order Management</span>
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={isHarvest ? "nav-link active" : "nav-link"}
                        onClick={() => redirectTo("/harvest-tracking")}
                        id="harvest-tracking-tab"
                    >
                        <HarvestIcon />
                        <span>Harvest Tracking</span>
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={isTransaction ? "nav-link active" : "nav-link"}
                        onClick={() => redirectTo("/transaction-history")}
                        id="transactions-tab"
                    >
                        <TransactionIcon />
                        <span>Transaction</span>
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default TabComponent;